import { Window } from "../../../ui/Window.js";
import { Layer } from "../Layer.js";
import { ColorScalePicker } from "../../../ui/color/ColorScalePicker.js";
import * as ColorScales from "../../../ui/color/colorScales.js";
import { Slider } from "../../../ui/slider/Slider.js";
import { Dropdown } from "../../../ui/Dropdown.js";

export { LayerSettings }

/**
 * @memberof vef.map.layer.utils
 */
class LayerSettings extends Window {

    constructor(target, options) {
        super(target, {
            height: "unset",
            width: "355px",
            open: false,
            draggable: true,
            responsive: true
        })

        this.options = options || {};

        this.colorChooser_ = this.initColorChooser_(this.options);
        this.opacitySlider_ = this.initOpacitySlider_();
        this.styleDropdown_ = this.initStyleDropdown_();

        this.containers_ = {};
        this.activeLayer_ = null;
        this.initContent_();
    }

    initColorChooser_(options) {
        const colorChooser = new ColorScalePicker();

        let colorPresets = {}
        if (options.colorPresets || (typeof options.colorPresets == "object")) {
            colorPresets = options.colorPresets;
        } else {
            for (let i in ColorScales) {
                for (let j in ColorScales[i]) {
                    colorPresets[i + " - " + j] = ColorScales[i][j];
                }
            }
        }

        colorChooser.setPresets(colorPresets);

        colorChooser.on("apply", (e) => {
            if (this.activeLayer_) {
                if (this.styleDropdown_) this.styleDropdown_.deselect();
                this.activeLayer_.setColorScale(colorChooser.getColorScale());
            }
        });

        return colorChooser;
    }

    initStyleDropdown_() {
        const dropdown = new Dropdown(null, {
            placeholder: "... select a style",
            showDeselectItem: false
        });

        dropdown.on("select", item => {
            if (this.activeLayer_) this.activeLayer_.setStyle(item.item);
        });

        return dropdown;
    }

    initOpacitySlider_() {
        const slider = new Slider(null, {
            handles: 1,
            min: 0,
            max: 1,
            value: 1,
            step: -1,
            stop: (opacity) => {
                if (this.activeLayer_) this.activeLayer_.setOpacity(opacity);
            }
        });

        return slider;
    }

    createContainer_(title, content, target) {
        const container = document.createElement("div");
        container.style.display = "none";
        container.innerHTML = "<h4>" + title + "</h4>"
        container.appendChild(content);
        target.appendChild(container);

        return container;
    }

    initContent_() {
        const element = document.createElement("div");

        this.containers_.styleDropdown = this.createContainer_("STYLES", this.styleDropdown_.getElement(), element);
        this.containers_.opacitySlider = this.createContainer_("OPACITY", this.opacitySlider_.getElement(), element);
        this.containers_.colorChooser = this.createContainer_("COLOR SCALE", this.colorChooser_.getElement(), element);

        this.setContent(element);
    }

    open(layer) {
        if (layer instanceof Layer) {
            this.activeLayer_ = layer;

            // style dropdown
            if (layer.styleSettings && Object.keys(layer.availableStyles).length) {
                // add empty style as default
                const items = {
                    "- default -": ""
                };
                for (let style in layer.availableStyles) {
                    items[style] = style;
                }
                this.styleDropdown_.setItems(items);
                this.styleDropdown_.select(layer.getStyle() || "- default -");
                this.containers_.styleDropdown.style.display = "block";
            } else {
                this.containers_.styleDropdown.style.display = "none";
            }

            // opacity slider
            if (layer.opacitySettings) {
                this.opacitySlider_.setValue(layer.getOpacity());
                this.containers_.opacitySlider.style.display = "block";
            } else {
                this.containers_.opacitySlider.style.display = "none";
            }

            // colorscale configurator
            if (layer.colorScaleSettings) {
                this.colorChooser_.setScale(layer.getColorScale());
                this.containers_.colorChooser.style.display = "block";
            } else {
                this.containers_.colorChooser.style.display = "none";
            }

            this.setTitle("STYLE: " + layer.title);
            super.open();
        } else {
            this.activeLayer_ = null;
            this.close();
        }
    }

}